/**
 * Check if an array of string / number values has undefined or null values.
 */
export function hasEmpty(...args: (string | number | null | undefined)[]) {
  return !args.every(arg => arg != null)
}
